import { useState } from 'react';
import { DateTime, TextField } from '@recargas-dominicanas/core/components';
import { useForm, validators } from '@recargas-dominicanas/core/utils';
import { Modal } from '../../../../components/modal/modal.component';
import { BankAccountStore } from '../../../../store/bankAccountStore';
import { style } from './register-deposit-modal.module.css';
import { CustomerApi } from '@recargas-dominicanas/core/adminApi';
import type { IBankAccount } from '@recargas-dominicanas/core/types';
import { BankAccountSelect } from '../../../../components/bank-account-select/bank-account-select.component';

interface Props {
  open: boolean;
  customerId: number;
  onUpdate: () => void;
  onClose: () => void;
}

export function RegisterDepositModal(props: Props) {

  const {
    open,
    customerId,
    onUpdate,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  const [disabledButton, setDisabledButton] = useState(false);
  const bankAccounts = BankAccountStore.getAll();

  const form = useForm({
    bankAccount: undefined as IBankAccount | undefined,
    date: '' as string | undefined,
    balance: '',
    reference: '',
    description: ''
  });

  function handleCancel() {
    form.clear();
    onClose();
    setError(undefined);
  }

  async function handleSave() {
    
    if (!form.isValid()) return;

    setDisabledButton(true);

    try {

      await CustomerApi.registerDeposit(customerId, {
        balance: parseInt(form.value.balance),
        bankAccountId: form.value.bankAccount!.id,
        date: new Date(form.value.date!),
        reference: form.value.reference,
        description: form.value.description
      });

      onUpdate();
      handleCancel();

    } catch {

      setError('Ocurrio un error al registrar el deposito');
    }

    setDisabledButton(false);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Registrar deposito'
      error={error}
      secondaryButton='Registrar'
      disabledSecondaryButton={disabledButton}
      onClose={handleCancel}
      onSecondaryClick={handleSave}>
      <BankAccountSelect 
        style={style.textField}
        label='Seleccionar cuenta bancaria'
        field={form.fields.bankAccount}
        bankAccounts={bankAccounts}/>
      <TextField
        style={style.textField}
        label='Balance'
        type='number'
        formField={form.fields.balance}
        validators={[validators.required]}/>
      <DateTime
        style={style.dateTime}
        label='Fecha'
        placeholder='Seleccionar fecha'
        type='datetime-local'
        formField={form.fields.date}
        required={true}/>
      <TextField
        style={style.textField}
        label='Referencia'
        formField={form.fields.reference}/>
      <TextField
        style={style.textField}
        label='Descripción'
        formField={form.fields.description}/>
    </Modal>
  );
}
